import { Input } from "antd";
import styled from "styled-components";
import { theme } from "../../../config";

export const Wrapper = styled.div`
  width: 100%;
  padding: 2px 12px;
  display: flex;
  align-items: center;
`;

export const StyledInput = styled(Input)`
  border: none;
  border-radius: 0px;
  border-bottom: solid 1px ${theme.colors.neutral.black1} !important;
  margin-left: 10px;
  box-shadow: none !important;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
`;

export const ErrorMessage = styled.div`
  padding: 0px 12px;
  color: ${theme.colors.utilities.error};
  font-size: 11px;
  line-height: 1.5715;
  text-align: end;
`;
